export default __webpack_public_path__ + "static/media/baby-ivy.02f69091.png";